// import mixin from '../../mixin'
import syncTransaction from '../../syncTransaction'

export function PassThroughActions(target) {

  const provider = target.prototype

  if (!provider.handleDelete) {
    provider.handleDelete = function handleDelete(e) {
      e.preventDefault()
      if (this.props.onDelete) {
        this.props.onDelete(this.props.current)
      }
    }
  }

  if (!provider.handleCancel) {
    provider.handleCancel = function handleCancel(e) {
      e.preventDefault()
      if (this.props.onCancel) {
        this.props.onCancel(this.props.current)
      }
    }
  }

  if (!provider.handleSave) {
    provider.handleSave = function handleSave(e) {
      e.preventDefault()
      if (this.props.onSave) {
        this.props.onSave(this.props.current)
      }
    }
  }

}

export function SyncActions(target) {

  const provider = target.prototype

  if (!provider.handleClose) {
    provider.handleClose = function handleClose() {
      this.props.router.goBack()
    }
  }

  if (!provider.handleDelete) {
    provider.handleDelete = function handleDelete(model) {
      return this::syncTransaction(model.destroy())
    }
  }

  if (!provider.handleSave) {
    provider.handleSave = function handleSave(model) {
      return this::syncTransaction(model.save())
    }
  }

}

// import mixin from '../../mixin'
// import syncTransaction from '../../syncTransaction'
//
// export const PassThroughActions = mixin({
//
//   handleDelete(e) {
//     e.preventDefault()
//     if (this.props.onDelete) {
//       this.props.onDelete(this.props.current)
//     }
//   },
//
//   handleCancel(e) {
//     e.preventDefault()
//     if (this.props.onCancel) {
//       this.props.onCancel(this.props.current)
//     }
//   },
//
//   handleSave(e) {
//     e.preventDefault()
//     if (this.props.onSave) {
//       this.props.onSave(this.props.current)
//     }
//   }
//
// })
//
// export const SyncActions = mixin({
//
//   handleClose() {
//     this.props.router.goBack()
//   },
//
//   handleDelete(model) {
//     return this::syncTransaction(model.destroy())
//   },
//
//   handleSave(model) {
//     return this::syncTransaction(model.save())
//   }
//
// })



// WEBPACK FOOTER //
// ./src/shared/decorators/form/actions.js